// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantMutations from "./CatalogVariantMutations.res.js";

function CatalogVariantArchiveModal(props) {
  let url = Navigation.useUrl();
  let navigate = Navigation.useNavigate();
  let match = Navigation.useGoBack();
  let onGoBack = match[1];
  let canGoBack = match[0];
  let archiveVariant = CatalogVariantMutations.useArchive(props.id);
  let fromVariantPage = url.pathname !== CatalogRoutes.baseRoute && !url.pathname.includes("/product");
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Once the variant is archived, it will only be visible in its product page and the catalog by applying the \"Archive\" filter."),
        variation: "normal"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    }),
    opened: props.opened,
    title: I18n.t("Confirm the archiving of this variant"),
    abortButtonText: I18n.t("Cancel"),
    commitButtonText: I18n.t("Confirm"),
    commitButtonCallback: () => Future.get(archiveVariant(), result => {
      if (result.TAG !== "Ok") {
        return;
      }
      if (canGoBack) {
        if (!fromVariantPage) {
          return;
        }
        if (url.pathname !== CatalogRoutes.baseRoute) {
          return onGoBack();
        }
      }
      if (fromVariantPage && url.pathname === CatalogRoutes.baseRoute) {
        return navigate(undefined, CatalogRoutes.baseRoute);
      }
    }),
    onRequestClose: props.onRequestClose
  });
}

let make = React.memo(CatalogVariantArchiveModal, (oldProps, newProps) => {
  if (oldProps.id === newProps.id) {
    return oldProps.opened === newProps.opened;
  } else {
    return false;
  }
});

let Mutations;

export {
  Mutations,
  make,
}
/* make Not a pure module */
